import React from "react";
import "./SearchComponent.css";
import { SearchIcon } from "../icons/Icons"; // Ensure this is correctly exported from your icons folder.

interface SearchComponentProps {
  placeholder?: string;
  onSearch?: (query: string) => void;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  placeholder = "Search",
  onSearch = () => {},
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };

  return (
    <div className="search-component">
      <div className="search-component__input-wrapper">
        <SearchIcon className="search-component__icon" />
        <input
          type="text"
          className="search-component__input"
          placeholder={placeholder}
          aria-label="Search input" // Accessibility improvement
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default SearchComponent;
